var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_6623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 14.6958C11.6816 14.6958 14.6663 11.711 14.6663 8.02909C14.6663 4.3472 11.6816 1.36243 7.99967 1.36243C4.31778 1.36243 1.33301 4.3472 1.33301 8.02909C1.33301 11.711 4.31778 14.6958 7.99967 14.6958Z",
    stroke: "#F9123B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6957V8.02905",
    stroke: "#F9123B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.36243H8.00667",
    stroke: "#F9123B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_6623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.0290527)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyIcon);
export default __webpack_public_path__ + "static/media/notify-icon.fd5a4355b91955356c1653867a8befa3.svg";
export { ForwardRef as ReactComponent };